import React from 'react';

import { LoadingContext } from '@/contexts';
import type { FacturesLoadingsType } from '@/types/facture';
import type { ModesReglementsLoadingsType } from '@/types/modeReglement';
import type { RecusLoadingsType } from '@/types/recu';

/**
 * Provider qui recence tout ce qui peut être en loading dans l'application
 */
const LoadingContextProvider = ({ children }: { children: React.ReactNode }) => {
  const [recusLoadings, setRecusLoadings] = React.useState<RecusLoadingsType>({
    recus: false,
  });
  const [facturesLoadings, setFacturesLoadings] = React.useState<FacturesLoadingsType>({
    factures: false,
  });
  const [payeurLoadings, setPayeurLoadings] = React.useState<FacturesLoadingsType>({
    factures: false,
  });

  const [modesReglementsLoadings, setModesReglementsLoadings] =
    React.useState<ModesReglementsLoadingsType>({
      modesReglements: false,
      regieModesReglement: false,
    });

  const context = React.useMemo(
    () => ({
      facturesLoadings,
      recusLoadings,
      modesReglementsLoadings,
      payeurLoadings,
      setFacturesLoadings,
      setRecusLoadings,
      setModesReglementsLoadings,
      setPayeurLoadings,
    }),
    [facturesLoadings, modesReglementsLoadings, payeurLoadings, recusLoadings],
  );

  return <LoadingContext.Provider value={context}>{children}</LoadingContext.Provider>;
};

export default LoadingContextProvider;
